import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconSizes } from '../../../components/foundations/Icon';
import { SunburstNodeType } from '../../types';
import Button from '../../../components/atoms/Button';
import Sunburst from '../sunburst/Sunburst';
import css from './VisualizationTabs.css';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ANOMALY_ANALYSIS';

const Tabs = {
    SUNBURST: { icon: 'target', translationKey: `${TRANSLATION_PREFIX}.TABS.SUNBURST`, component: Sunburst },
};

const TAB_ENTRIES = Object.entries(Tabs);

const VisualizationTabs = ({ data, isLoading, error, hasQueried }) => {
    const [activeTab, setActiveTab] = useState(Object.keys(Tabs)[0]);

    const { component: ActiveComponent } = Tabs[activeTab];

    return (
        <div className={css.container}>
            <div className={css.tabsRow}>
                {TAB_ENTRIES.map(([name, tab]) => (
                    <Button
                        key={name}
                        type={activeTab === name ? 'primary' : 'secondary'}
                        Icon={tab.icon}
                        iconSize={IconSizes.X_SMALL}
                        text={tab.translationKey}
                        onClick={() => setActiveTab(name)}
                        className={css.tab}
                    />
                ))}
            </div>
            <div className={css.tabContent}>
                <ActiveComponent data={data} isLoading={isLoading} error={error} hasQueried={hasQueried} />
            </div>
        </div>
    );
};

VisualizationTabs.propTypes = {
    data: PropTypes.arrayOf(SunburstNodeType),
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    hasQueried: PropTypes.bool,
};

export default VisualizationTabs;
